import React, { useState } from "react";
import { Box, Collapse } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CustomLink from "../link";
import CustomTypography from "../typography";

import "./styles.scss";

const classNameBase = "scd-show-more-less-info";

interface ShowMoreLessInfoProps {
  title: string;
  children: React.ReactNode;
  label: {
    showMore: string;
    showLess: string;
  };
}

export default function ShowMoreLessInfo({
  title,
  children,
  label,
}: ShowMoreLessInfoProps): React.JSX.Element {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box className={`${classNameBase}-container`} component="div">
      <Box className={`${classNameBase}-titlebox`} component="div">
        <CustomTypography
          variant={"body1"}
          className={`${classNameBase}-title`}
        >
          {title}
        </CustomTypography>
      </Box>
      <Collapse
        in={expanded}
        className={`${classNameBase}-content`}
        classes={{ wrapperInner: `${classNameBase}-wrapperInner` }}
        unmountOnExit // --> removes the div from the dom if the component is collapsed.
      >
        {children}
      </Collapse>
      {expanded ? (
        <CustomLink noicon onClick={() => setExpanded(false)}>
          <ExpandLess className={`${classNameBase}-link-icon expand-less`} />
          {label.showLess}
        </CustomLink>
      ) : (
        <CustomLink noicon onClick={() => setExpanded(true)}>
          <ExpandMore className={`${classNameBase}-link-icon expand-more`} />
          {label.showMore}
        </CustomLink>
      )}
    </Box>
  );
}
